import styled, { css } from 'styled-components';
import { DropdownMenu } from '@montel/montelpro-shared-components-v2';

export const StyledDivider = styled.div<{ $breakpoint?: string }>`
	width: 0.0625rem;
	${({ $breakpoint = 'lg', theme }) => {
		const { colors, spacing } = theme;
		const isMobile = ['xxxs', 'xxs', 'xs'].includes($breakpoint);

		return css`
			height: ${isMobile ? '2rem' : '3rem'};
			background-color: ${colors.subElement};
			margin-right: ${spacing.xs};
		`;
	}}
`;

export const StyledProfileMenuItem = styled.li<{ $isActive?: boolean }>`
	cursor: pointer;
	height: 100%;

	${({ theme, $isActive }) => {
		const { colors, spacing, borderRadii } = theme;
		const { sm } = borderRadii;
		return css`
			color: ${colors.textDefault};
			background-color: ${$isActive ? colors.bgBrand : colors.bgCard};
			> * {
				padding: ${spacing.xs} ${spacing.md};
			}
			&:focus {
				${!$isActive && `background: ${colors.bgBrandHover};`};
			}
			&:hover {
				${!$isActive && `background: ${colors.bgBrandHover};`};
				cursor: ${!$isActive ? 'pointer' : 'default'};
				&:first-child {
					border-radius: ${sm} ${sm} 0 0;
				}
				&:last-child {
					border-radius: 0 0 ${sm} ${sm};
				}
			}
			a {
				padding: 0;
				outline: none;
				> * {
					padding: ${spacing.xs} ${spacing.md};
				}
			}
		`;
	}}
`;

export const StyledProfileContainer = styled(DropdownMenu)`
	width: 256px;
	right: 0.5rem;
	overflow: hidden;
`;
